import { render, staticRenderFns } from "./Exodontias.vue?vue&type=template&id=6c37849f"
import script from "./Exodontias.vue?vue&type=script&lang=js"
export * from "./Exodontias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports